//----------------------------------------------------
// src/services/userService.js — API-calls voor rolbeheer
//----------------------------------------------------
import axios from "axios";
import { API_BASE_URL } from "../config/api";

const API_URL = API_BASE_URL;

// 🔹 Gebruikers per tenant ophalen
export async function getUsersByTenant(tenantId, token) {
  const res = await axios.get(`${API_URL}/auth/users/${tenantId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
}

// 🔹 Rol van gebruiker wijzigen
export async function updateUserRole(userId, nieuweRol, token) {
  const res = await axios.put(
    `${API_URL}/auth/role/${userId}`,
    { nieuweRol },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
}
